import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  sessions: [],
  session: null
}

// mutations
export const mutations = {
  [types.SET_SESSIONS] (state, sessions) {
    sessions.per_page = parseInt(sessions.per_page)
    state.sessions = sessions
  },
  [types.SET_SESSION] (state, session) {
    state.session = session
  },
  [types.FETCH_SESSION_FAILURE] (state) {
    state.session = null
  }
}

// actions
export const actions = {
  async fetchSessions ({ commit }, payload) {
    try {
      const { data } = await axios.get('/api/sessions', {
        params: payload || ''
      })
      commit(types.SET_SESSIONS, data)
    } catch (e) {
      console.log(e)
    }
  },
  async fetchSession ({ commit }, session) {
    try {
      const { data } = await axios.get(`/api/sessions/${session.id}`)

      commit(types.SET_SESSION, { session: data })
    } catch (e) {
      commit(types.FETCH_SESSION_FAILURE)
    }
  }
}

// getters
export const getters = {
  sessions: state => state.sessions
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/session.js